var BillingModule = (function () {
    function BillingModule() {
    }
    return BillingModule;
}());
export { BillingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/billing/billing.module.ts.pre-build-optimizer.js